import { createApp } from 'vue'
import Sustainability from './Sustainability.vue'

createApp(Sustainability).mount('#sustainability')
